import { usePopupActions, usePopupSelector } from "../store/popupStore";

/**
 * Controls UI state and interactions for the Entity Map modal.
 *
 * Now reads directly from popupStore — no longer bridges two stores.
 * showModal  = popupType !== null
 * visibleContent = isContentVisible && !isContentCollapsed
 * hasMapViewSwitch = only media-viewer popup has the "Switch to Map" toggle
 */
export default function useEntityMapModalController() {
  const { popupType, isContentVisible, isContentCollapsed } = usePopupSelector();
  const { closePopup, toggleContent } = usePopupActions();

  return {
    showModal: popupType !== null,
    visibleContent: isContentVisible && !isContentCollapsed,
    toggleContent,
    toggleModal: closePopup,
    /** true only for media-viewer — controls visibility of "Switch to Map" button */
    hasMapViewSwitch: popupType === "media-viewer"
  } as const;
}
